<template>
  <div class="experience-textbox">
    <input
      type="text"
      readonly
      class="form-control"
      v-model="title"
      @click="onClickTextbox"
    />
    <v-dialog v-model="showSuggestionDialog">
      <div class="suggestion-dialog">
        <v-card>
          <v-card-text>
            <form
              class="suggesion-dialog-form"
              @submit.prevent="onSubmitSuggestionForm"
            >
              <div class="form-group">
                <input
                  type="text"
                  class="suggestion-textbox form-control"
                  placeholder="Start typing"
                  @input="onInputSuggestionText"
                  ref="suggestionInput"
                />
              </div>
              <div class="results">
                <div
                  class="result-item"
                  v-for="(item, index) of suggestedResults"
                  :key="index"
                  @click="onClickSuggestedItem(item)"
                >
                  <strong>{{ item.title }}</strong
                  >&nbsp;<span class="address">{{ item.address }}</span>
                </div>
              </div>
              <div class="form-actions d-flex justify-content-between">
                <input type="submit" value="Confirm" class="btn btn-info" />
                <input
                  type="reset"
                  value="Cancel"
                  class="btn"
                  @click="close()"
                />
              </div>
            </form>
          </v-card-text>
        </v-card>
      </div>
    </v-dialog>

    <v-dialog v-model="showClaimDialog">
      <div class="experience-claim-dialog">
        <v-card>
          <v-card-text>
            <form
              @submit.prevent="onSubmitClaimForm"
              class="experience-claim-form"
            >
              <p>
                This experience has already been claimed. Please contact us to
                request ownership of the experience.
              </p>
              <div class="form-group">
                <textarea
                  class="form-control"
                  v-model="claimForm.message"
                ></textarea>
              </div>
              <div class="form-group">
                <p>Upload proof of ownership (optional)</p>
                <button
                  class="btn btn-block text-uppercase"
                  @click.prevent="onClickUploadProofFile"
                >
                  Choose a file from your computer
                </button>
                <input
                  type="file"
                  class="proof-file-input"
                  ref="proofFile"
                  @change="onProofFileChange"
                />
                <div class="proof-file-name" v-if="proofFileName">
                  {{ proofFileName }} (<a
                    href="javascript:void(0);"
                    class="text-danger clickable"
                    @click="onClickRemoveProofFile"
                    >Remove</a
                  >)
                </div>
              </div>
              <div class="form-actions d-flex justify-content-between">
                <input type="submit" value="Confirm" class="btn btn-info" />
                <input
                  type="reset"
                  value="Cancel"
                  class="btn"
                  @click="onCloseClaimForm"
                />
              </div>
              <div
                class="claim-success text-success text-center mt-2"
                v-if="claimSuccess"
              >
                Claiming request has been sent. Our administrator will review as
                soon as possible.
              </div>
              <div
                class="claim-error text-danger text-center mt-2"
                v-if="claimError"
              >
                Sorry, Claiming process failed. Please try again later.
              </div>
            </form>
          </v-card-text>
        </v-card>
      </div>
    </v-dialog>

    <v-dialog v-model="showNewExperienceDialog">
      <div class="new-experience-dialog">
        <v-card>
          <v-card-text>
            <form
              @submit.prevent="onSubmitNewExperienceForm"
              class="new-experience-form"
            >
              <div class="form-group row">
                <label for="address" class="form-control-label col-md-3 py-1"
                  >Address</label
                >
                <div class="col-md-9 py-1">
                  <input
                    id="address"
                    type="text"
                    class="form-control"
                    v-model="newForm.address"
                  />
                </div>
              </div>
              <LocationPicker
                ref="locationPicker"
                :model="newForm"
                :labelGridLength="3"
                :controlGridLength="9"
                @change="onLocationPickerChange"
              />
              <div class="form-group row">
                <label for="map" class="form-control-label col-md-3 py-1"
                  >Map</label
                >
                <div class="col-md-9">
                  <MapPicker @change="onMapChange" height="250px" />
                </div>
              </div>
              <div class="position-tips">Enter Coordinates manually</div>
              <div class="form-group row">
                <label for="position" class="form-control-label col-md-4 py-1"
                  ><img :src="images.markerGray" class="ml-2"
                /></label>
                <div class="col-md-4 py-1">
                  <input
                    class="form-control"
                    type="number"
                    step="0.00001"
                    v-model="newForm.position.latitude"
                  />
                </div>
                <div class="col-md-4 py-1">
                  <input
                    class="form-control"
                    type="number"
                    step="0.00001"
                    v-model="newForm.position.longitude"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="what3words" class="form-control-label col-md-4 py-1"
                  ><img :src="images.what3wordsIcon"
                /></label>
                <div class="col-md-8 py-1">
                  <input
                    id="what3words"
                    type="text"
                    class="form-control"
                    v-model="newForm.what3words"
                  />
                </div>
              </div>
              <div class="form-actions d-flex justify-content-between">
                <input type="submit" value="Confirm" class="btn btn-info" />
                <input
                  type="reset"
                  value="Cancel"
                  class="btn"
                  @click="closeNewForm"
                />
              </div>
            </form>
          </v-card-text>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import MapPicker from "@/components/MapPicker";
import LocationPicker from "@/components/LocationPicker";
import { debounce, merge } from "lodash";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import markerGray from "@/assets/images/marker-gray.svg";
import what3wordsIcon from "@/assets/images/what3words-alt.svg";

const defaultNewForm = {
  address: "",
  country: null,
  region: null,
  district: null,
  position: {
    latitude: null,
    longitude: null,
  },
  what3words: "",
};

export default {
  components: {
    MapPicker,
    LocationPicker,
    PerfectScrollbar,
  },
  data() {
    return {
      title: "",
      claimForm: {
        message: "",
        proofFile: null,
      },
      newForm: { ...defaultNewForm },
      selectedId: null,
      suggestedResults: [],
      showSuggestionDialog: false,
      showClaimDialog: false,
      showNewExperienceDialog: false,
      proofFileName: "",
      claimSuccess: false,
      claimError: false,
      images: {
        markerGray,
        what3wordsIcon,
      },
    };
  },
  methods: {
    async syncData(data) {
      this.title = data.title;
      this.newForm.address = data.address;
      this.newForm.country = data.country;
      this.newForm.region = data.region;
      this.newForm.district = data.district;
      this.newForm.position.latitude = data.position.latitude;
      this.newForm.position.longitude = data.position.longitude;
      this.newForm.what3words = data.what3words;
    },
    onClickTextbox() {
      this.showSuggestionDialog = true;
      if (this.$refs.suggestionInput) {
        this.$refs.suggestionInput.select();
      }
    },
    onInputSuggestionText: debounce(async function (e) {
      this.title = e.target.value;
      const { results } = await this.$repo.exp.getSuggestedExperiences(
        this.title
      );
      this.suggestedResults = results;
    }, 500),
    onClickSuggestedItem(item) {
      this.selectedId = item.id;
      this.title = item.title;
      if (item.exists) {
        this.showSuggestionDialog = false;
        this.showClaimDialog = true;
      } else {
        this.showSuggestionDialog = false;
        this.showNewExperienceDialog = true;
      }
    },
    async onSubmitSuggestionForm() {
      this.$emit("new", {
        title: this.title,
      });
      this.showSuggestionDialog = false;
    },
    async onSubmitClaimForm() {
      this.claimSuccess = false;
      this.claimError = false;
      try {
        const isClaimSuccess = await this.$repo.exp.claimExperience(
          this.selectedId,
          this.claimForm
        );
        this.resetClaimForm();
        if (isClaimSuccess) {
          this.claimSuccess = true;
        } else {
          this.claimError = true;
        }
      } catch {
        this.resetClaimForm();
        this.claimError = true;
      }
    },
    onClickUploadProofFile() {
      this.$refs.proofFile.click();
    },
    onProofFileChange(e) {
      const files = e.target.files;
      if (files && files.length > 0) {
        this.claimForm.proofFile = files[0];
        this.proofFileName = files[0].name;
      } else {
        this.proofFileName = "";
      }
    },
    onClickRemoveProofFile() {
      this.claimForm.proofFile = null;
      this.$refs.proofFile.value = null;
      this.proofFileName = "";
    },
    onCloseClaimForm() {
      this.resetClaimForm();
      this.showClaimDialog = false;
    },
    resetClaimForm() {
      this.claimForm.message = "";
      this.claimForm.proofFile = null;
      this.proofFileName = "";
      this.claimError = false;
      this.claimSuccess = false;
    },
    onSubmitNewExperienceForm() {
      const data = merge(
        {
          title: this.title,
        },
        this.newForm
      );
      this.$emit("new", data);
      this.closeNewForm();
    },
    close() {
      this.showSuggestionDialog = false;
    },
    onLocationPickerChange(data) {
      this.newForm.country = data.country;
      this.newForm.region = data.region;
      this.newForm.district = data.district;
    },
    onMapChange(pos) {
      this.newForm.position.latitude = pos.latitude.toFixed(5);
      this.newForm.position.longitude = pos.longitude.toFixed(5);
    },
    closeNewForm() {
      this.showNewExperienceDialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
.suggestion-dialog {
  width: 400px;
  margin: 0 auto;

  input[type="text"] {
    font-size: 12px;
  }

  .results {
    min-height: 80px;

    .result-item {
      font-size: 12px;
      margin-bottom: 5px;
      cursor: pointer;
    }
  }

  .form-actions {
    & > input {
      width: 48%;
      font-size: 14px;
    }
  }
}

.experience-claim-dialog {
  width: 430px;
  margin: 0 auto;
  font-size: 12px;

  form {
    margin: 14px 24px;
    font-size: 12px;
  }

  .form-control-label,
  .form-control {
    font-size: 12px;
  }

  textarea {
    height: 115px;
  }

  .proof-file-input {
    display: none;
  }

  .proof-file-name {
    margin: 10px auto;
    text-align: center;
  }
}

.new-experience-dialog {
  width: 520px;
  margin: 0 auto;

  .new-experience-form {
    font-size: 12px;
  }

  label,
  select,
  input,
  .form-control,
  .form-control-label {
    font-size: 12px;
  }

  .map-container {
    width: 100%;
    height: 150px;
  }
}
</style>